<template>

  <div class="box-body">
    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span class="ess">이름</span>
      </label>
      <div class="col-6 pt-2">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <input type="text" name="방문자 이름" class="form-control form-control-danger" v-model="item.visitorName"/>
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span class="ess">회사명</span>
      </label>
      <div class="col-6 pt-2">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <input type="text" name="방문자 회사명" class="form-control form-control-success" v-model="item.visitorCompany"/>
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span class="ess">연락처</span>
      </label>
      <div class="col-6 pt-2">
        <!-- TODO 전화번호 Validation-->
        <ValidationProvider rules="required|phone" v-slot="{ errors }">
          <input type="text" name="방문자 전화번호" class="form-control form-control-success" v-model="item.visitorPhone" @keyup="phoneValid"/>
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span class="ess">이메일</span>
      </label>
      <div class="col-6 pt-2">
        <ValidationProvider rules="required|email|min:6" v-slot="{ errors }">
          <input type="text" name="방문자 이메일" class="form-control form-control-success" v-model="item.visitorMail" @blur="checkEmpEmail"/>
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
        <div class="m-t-sm">
          방문 승인 완료 후, 입력하신 메일주소로 출입용 QR코드가 발급됩니다. 반드시 사용 가능한 메일 주소를 입력해주세요.
        </div>
      </div>
    </div>
    <div class="form-group row" v-if="this.$route.query.locationCode == 'N2CDT010320'">
      <label class="col-2 form-control-label">
        <span class="ess">생년월일</span>
      </label>
      <div class="col-6 pt-2">
        <ValidationProvider  rules="required" v-slot="{ errors }" name="생년월일">
          <div class="input-group date">
            <DatePicker class="form-control"
                        default-panel="date"
                        :append-to-body="false"
                        :popup-style="{ left: 0}"
                        v-model="item.visitorBirth"
                        :clearable="false"
                        :editable="false"
                        style="font-size: 12px;"
                        input-class="calendar-input"
                        :lang="lang"
            >
              <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
            </DatePicker>
          </div>
          <div>
            <span class="input-error">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span>반입자산</span>
      </label>
      <div class="col-10 pt-2">
        <asset-table v-model="item.assetList"/>
      </div>
    </div>
    <div class="form-group row pt-10" v-if="!isApplicant">
      <label class="col-12 form-control-label ">
          <small>
            <label class="md-check">
            <input type="checkbox" v-model="item.isAgree" @change="checkHandler">
            <i class="blue"></i><span style="color: red;">추가 방문자의 개인정보 수집 및 이용에 대한 동의를 획득하였음을 확인합니다.</span></label>
          </small>
      </label>
    </div>

    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span class="">차종</span>
      </label>
      <div class="col-6 pt-2">
        <ValidationProvider rules="min:2" v-slot="{ errors }">
          <input type="text" name="차종" class="form-control form-control-danger" v-model="item.carModel"/>
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label">
        <span class="">차량번호</span>
      </label>
      <div class="col-6 pt-2">
        <ValidationProvider rules="min:7" v-slot="{ errors }">
          <input type="text" name="차량번호" class="form-control form-control-danger" v-model="item.carNumber"/>
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
  import AssetTable from './AssetTable.vue'
  import DatepickerOptions from '@/components/common/datepickerOptions'
  export default {
    props: {
      item: { type: Object, default: function(){ return {assetList:[]}}},
      isApplicant: { type: Boolean},
    },
    components: { AssetTable, DatepickerOptions },
    mixins: [DatepickerOptions],
    data(){
      return {
        // item: {}
      }
    },
    mounted(){
      this.item.isAgree = Number(this.isApplicant)
    },
    methods : {
      phoneValid() {
        this.item.visitorPhone = this.item.visitorPhone.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
      },
      checkEmpEmail() {
        //임직원 이메일 정보 확인.
        this.$http.get('/api/public/isEmp/'+this.item.visitorMail)
          .then((result) => {
            if(result.data) {
              this.noti('임직원 신청 불가', '내부 임직원은 NTREE의 IDC 출입예약 요청서를 사용해 주세요.', 'warning');
              this.item.visitorMail = null;
            }
          }).catch((e) =>{
            that.$emit('dataTableFindEnd');
            console.log(e);
          })
      }
    }
  }
</script>

<style>
  /*.mx-btn-icon-double-left, .mx-btn-icon-double-right{*/
    /*display: block;*/
  /*}*/
</style>
